<template>
  <div class="box7">
    <pageTitle
      title="专家级阵容保驾护航<br/>35天实战技能全栈交付"
      text="四大实战派导师倾囊相授，直通行业核心竞争力"
    />

    
    <div class="teacher-box">
      <div
        class="teacher"
        v-for="(item, index) in list"
        :key="index"
       
        @click="changeCur(index)"
      >
        <img :src="require(`../../../assets/coursePage/trainer/07/${index + 1}.png`)" />
        <div class="teacher-inner">
          <b v-html="item.b"></b>
          <div class="tName">{{ item.name }}老师</div>
          <p v-html="item.p"></p>
        </div>
      </div>
    </div>

    <van-popup v-model="show" position="bottom" round>
      <div class="pop">
        <div class="pop-top">
          <div class="title">{{ list[this.cur].name }}老师</div>

          <div class="close" @click="show = false"></div>
        </div>

        <div class="tag-box">
          <div
            class="tag"
            v-for="(item, index) in list[this.cur].tag"
            :key="index"
            :class="'tag' + (index + 1)"
          >
            {{ item }}
          </div>
        </div>

        <p
          v-for="(j, index1) in list[cur].info"
          :key="index1"
          
        >
          <span></span>
          {{ j }}
        </p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      cur: 0,
      show: false,
      list: [
        {
          name: "王",
          b:"AI智能应用开发",
          tag: ["AI智能应用开发", "15年央企架构实战专家"],
          p: "15年央企架构实战专家",
          info: [
            "前数字中台高级架构师，主导支付/营销/供应链核心系统研发，跨在线教育、金融、电商三领域深耕，传智教育架构学科带头人输送500+一线架构师，现任AI智能体开发负责人推动大厂技术企业落地。"
          ],
        },
        {
          name: "许",
          b:"AI测试",
          tag: ["AI测试", "10年测试全栈实战专家"],
          p: "10年测试全栈实战专家",
          info: [
            "软件测试开发、质量管理、项目管理资深专家，精通Java/Python，覆盖功能/接口/自动化/性能/大模型/智能体测试全链路，教学幽默风趣，教学经验丰富能充分调动学员积极性。",
          ],
        },
       
        {
          name: "姚",
          b:"AI大模型",
          p: "GIS行业工程实战专家",
          tag: ["AI大模型", "GIS行业工程实战专家"],
          info: [
           
            "哈尔滨工程大学毕业，深耕GIS行业工程实战，多年图像分割、检测、追踪经验，参与多项国家级/部委级重大项目，拥有丰富的工程落地实战能力。",
          ],
        },
         {
          name: "刘",
          b:"AI测试",
          tag: ["AI测试","13年测试深耕领军人物"],
          p: "13年测试深耕领军人物",
         
          info: [
            "黑马AI测试学科课研负责人，前国企质量负责人，精通B/C端功能、自动化、性能测试，近3年专注AI大模型与智能体测试，将前沿实战经验赋能团队质效跃升。",
          ],
        },
      ],
    };
  },
  methods: {
    changeCur(index) {
      this.show = true;
      this.cur = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.box7 {
  padding: 80px 0 58px;
  width: 100%;
  background: url("../../../assets/coursePage/ai/box10/bg.png") no-repeat;
  background-size: cover;

  .word {
    white-space: nowrap;
  }

  

  .teacher-box {
    display: flex;
    justify-content: start;
    flex-wrap: wrap;
    margin: 48px auto 0 32px;

    .teacher {
     width: 328px;
      height: 448px;
      background: linear-gradient( 132deg, rgba(231,249,254,0.57) 0%, #D5E9F9 100%), #F5F9FA;
      border-radius: 40px;
      margin-right: 30px;
      margin-bottom: 30px;
      padding: 16px;
      box-sizing: border-box;
      position: relative;
      .teacher-inner{
        background: #FFFFFF;
        border-radius: 24px;
        padding: 32px 0 40px 32px;
        margin-top: 200px;
        width: 100%;
        height: 216px;
        overflow: hidden;
        box-sizing: border-box;
        position: relative;

      }
      img{
        width: 280px;
        position: absolute;
        top:16px;
        left: 24px;

      }
      .tName {
       font-family: SourceHanSansSC, SourceHanSansSC, PingFang SC;
        font-weight: 500;
        font-size: 28px;
        color: #0F2654;
        line-height: 40px;
        text-align: left;
        font-style: normal;
        margin: 24px 0 8px;
      }
      p {
       font-family: SourceHanSansSC, SourceHanSansSC, PingFang SC;
font-weight: 400;
font-size: 24px;
color: #6E7F94;
line-height: 36px;
text-align: left;
font-style: normal;

      }
      b{
        font-family: SourceHanSansSC, SourceHanSansSC, PingFang SC;
font-weight: 400;
font-size: 24px;
color: #6E7F94;
line-height: 36px;
text-align: left;
font-style: normal;
      }
    }
  }

  .pop {
    padding: 40px 46px;
    padding-bottom: 80px;

    box-sizing: border-box;
    .pop-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      .title {
        height: 48px;
        font-size: 32px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #1d2129;
        line-height: 48px;
      }
    }
    .close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }

    .tag-box {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 32px;
    }

    .tag {
      margin-right: 16px;
      padding: 0px 16px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      background: #e8f3ff;
      border-radius: 8px;

      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #165dff;
    }

    .tag2 {
      height: 44px;
      background: #fff7e8;
      border-radius: 8px;

      color: #ff7d00;
    }

    p {
      position: relative;
      // display: flex;
      margin-bottom: 16px;
      padding-left: 24px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;

      span {
        position: absolute;
        top: 16px;
        left: 0px;
        margin-right: 16px;
        min-width: 8px;
        height: 8px;
        background: #becfff;
        border-radius: 50%;
      }
    }
  }
}
</style>
